const store = {
    namespaced: true,
    state() {
        return {
            product: null,
            isLoading: false
        }
    },
    getters: {
        product(state) {
            return state.product;
        },
        isLoading(state) {
            return state.isLoading;
        }
    },
    mutations: {
        setProduct(state, product) {
            state.product = product;
        },
        setIsLoading(state, isLoading) {
            state.isLoading = isLoading;
        }
    },
    actions: {
        async fetchProduct({ commit }, { color = 'venge' } = 'venge') {
            commit('setIsLoading', true);
    
            const url = color ? `-${color}` : '';
            try {
                const productData = await import(`~/JsonDB/novaPorta${url}.json`);
                commit('setProduct', productData.default.product);
            } catch (error) {
                console.error('Error fetching product:', error);
            } finally {
                commit('setIsLoading', false);
            }
        }
    }
}

export default store